import React, {ForwardedRef, forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState} from 'react';
import User from '../../../models/userModel';
import {ActivateHandle} from '../../../util/interfaces';
import {PRODUCTS_INTRO_SEEN_FLEX_KEY, shouldShowProductsIntro} from '../../../util/productsUtil';
import {createSnoozeFor} from '../../../util/snoozeUtil';
import {AppContext} from '../../misc/appContext';
import IntroDialog from './introDialog';

const INTRO_FEATURE_KEY = 'products-intro';
const PERMANENT = [Number.POSITIVE_INFINITY];

function introSnooze(user: User) {
    return createSnoozeFor({featureKey: INTRO_FEATURE_KEY, scope: user.id, cooldowns: PERMANENT});
}

function IntroDialogController(_props: object, ref: ForwardedRef<ActivateHandle>) {
    const {userContext, onChangeContext} = useContext(AppContext);
    const {user} = userContext;
    const [active, setActive] = useState(false);
    const decidedRef = useRef(false);

    function onActivate() {
        setActive(true);
    }

    function onDismiss() {
        if (user) introSnooze(user).recordDismissal();
        setActive(false);
        if (user && !user.isDemoAccount) persistSeen(user);
    }

    function persistSeen(user: User) {
        const updated = user.clone();
        updated.setFlex(PRODUCTS_INTRO_SEEN_FLEX_KEY, true);
        updated.update(undefined, (saved: User, success: boolean) => {
            if (success) onChangeContext({user: saved});
        });
    }

    useEffect(() => {
        if (decidedRef.current || !user) return;
        decidedRef.current = true;
        if (introSnooze(user).isSnoozed() || !shouldShowProductsIntro(user)) return;
        setActive(true);
    }, [user]);

    useImperativeHandle(ref, () => ({activate: onActivate}));

    return <IntroDialog onClose={onDismiss} onConfirm={onDismiss} active={active} />;
}

export default forwardRef<ActivateHandle>(IntroDialogController);
